module.exports = __webpack_public_path__ + "img/cancel.49e43604.png";